<template>
  <v-container container--fluid grid-list-lg>
    <v-row justify="space-around" align="center" :class="{'justify-center': $vuetify.breakpoint.smAndDown}">
      <v-col cols="12" md="3">
        <v-select
          :items="regions"
          v-model="manifest.region_id"
          label="Region..."
          prepend-inner-icon="map"
          item-text="name"
          item-value="id"
        ></v-select>
      </v-col>
      <v-col cols="12" md="4">
        <v-autocomplete
          v-model="manifest.client_id"
          label="Choose Client..."
          :items="clients"
          item-text="name"
          item-value="id"
          :disabled="isNew"
          clearable
          prepend-inner-icon="people"
        >
        </v-autocomplete>
      </v-col>
      <v-col cols="3" md="2">
        <v-text-field type="number" label="Skip Rows..." prepend-inner-icon="skip_next"
                      v-model="manifest.skip_rows"></v-text-field>
      </v-col>
    </v-row>
    <v-row justify="space-around" align="center" :class="{'justify-center': $vuetify.breakpoint.smAndDown}">
      <v-col cols="3" md="1">
        <v-checkbox class="text-center" label="Consolidate Tags" icon="local_offer" v-model="manifest.consolidate_tags">
        </v-checkbox>
      </v-col>
      <v-col cols="3" md="1">
        <v-checkbox class="text-center" label="Generate Serials" icon="local_offer" v-model="manifest.generate_serials">
        </v-checkbox>
      </v-col>
      <v-col cols="3" md="1">
        <v-checkbox class="text-center" label="Multi Day" icon="local_offer" v-model="manifest.multi_day">
        </v-checkbox>
      </v-col>
      <v-col cols="3" md="1">
        <v-checkbox class="text-center" label="Multi Window" icon="local_offer" v-model="manifest.multi_window">
        </v-checkbox>
      </v-col>
      <v-col cols="3" md="1">
        <v-checkbox class="text-center" label="Multi Region" icon="local_offer" v-model="manifest.multi_region">
        </v-checkbox>
      </v-col>
      <v-col cols="3" md="1">
        <v-checkbox class="text-center" label="Unique Tags" icon="local_offer" v-model="manifest.unique_tags">
        </v-checkbox>
      </v-col>
      <v-col cols="3" md="1">
        <v-checkbox class="text-center" label="Line Haul" icon="local_offer" v-model="manifest.enable_linehaul">
        </v-checkbox>
      </v-col>
      <v-col cols="3" md="1">
        <v-checkbox class="text-center" label="Production" icon="local_offer" v-model="manifest.enable_production">
        </v-checkbox>
      </v-col>
      <v-col cols="3" md="1" v-if="manifest.id > -1" class="text-center">
        <v-tooltip top color="secondary">
          <template v-slot:activator="{ on }">
            <v-btn text color="red" icon v-on="on" @click="deleteDialog = true">
              <v-icon color="red">delete</v-icon>
            </v-btn>
          </template>
          <span>Delete this manifest format</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12" md="6">
        <v-expansion-panels accordion>
          <v-expansion-panel
            v-for="(code, index) in codes"
            v-if="index < 1"
            :key="index"
          >
            <v-expansion-panel-header>
              <h2>{{code.text}}</h2>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="grid-container">
              <div v-for="(item,index) in manifestFormatList" :key="index" class="grid-item">
                <span class="item-name">{{item.name}}:</span>
                <input v-model.number="item.value" type="number" min=0 max=50 @input="updateManifestFormat"/>
              </div>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
      <v-col cols="12" md="6">
        <v-expansion-panels accordion>
          <v-expansion-panel
            v-for="(code, index) in codes"
            v-if="index >= 1"
            v-show="isAdmin"
            :key="index"
          >
            <v-expansion-panel-header>
              <h2>{{code.text}}</h2>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <prism-editor v-model="manifest[code.model]" language="js" line-numbers
                            class="editor"></prism-editor>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <v-row class="mt-6" justify="center" :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
      <v-btn text color="blue-grey lighten-2" @click="$emit('cancel')">Cancel</v-btn>
      <v-tooltip top color="secondary">
        <template v-slot:activator="{ on }">
          <v-btn text color="primary" @click="save" v-on="on">{{manifest.id > -1 ? 'Save' : 'Create'}}</v-btn>
        </template>
        <span>
            {{manifest.id > -1 ? 'Save and edit changes on this manifest format' : 'Create this manifest format'}}
          </span>
      </v-tooltip>

    </v-row>

    <v-dialog v-model="deleteDialog" width="500px">
      <v-card>
        <v-card-title class="justify-center">
          <h2>ALERT</h2>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="text-center">
          <v-container container--fluid>
            You are about to delete this manifest. <br>
            This action cannot be undone, are you sure you want to proceed ?
          </v-container>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text color="red" @click="deleteDialog=false">No</v-btn>
          <v-btn text color="blue darken-1" @click="deleteManifest">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
    import PrismEditor from 'vue-prism-editor'
    import axios from 'axios'

    // @vuese
    // Edit Manifest tab of the Manage Manifests page
    // @group Manage Manifests
    export default {
        name: "EditManifest",
        components: {PrismEditor},
        props: {
            // @vuese Client Object associated to the manifest the user clicked on
            client: Object,
            // @vuese Manifest Object the user clicked on
            manifest: Object,
            isNew:Boolean,
        },
        data() {
            return {
                deleteDialog: false,
                regions: null,
                region: null,
                clients: null,
                lineNumbers: null,
                defaultScripts: {
                    format: null,
                    constants: null,
                },
                manifestFormatList:[
                  {name:'Stop Name',value:null},
                  {name:'Company',value:null},
                  {name:'Address',value:null},
                  {name:'Address2',value:null},
                  {name:'City',value:null},
                  {name:'State',value:null},
                  {name:'Postal Code',value:null},
                  {name:'Phone',value:null},
                  {name:'Window Start',value:null},
                  {name:'Window End',value:null},
                  {name:'Date',value:null},
                  {name:'Instructions',value:null},
                  {name:'Invoice',value:null},
                  {name:'Serial',value:null},
                  {name:'Production Date',value:null},
                  {name:'Consolidation Depot Name',value:null},
                  {name:'Item SKU',value:null},
                  {name:'Quantity',value:null}
                ],
                codes: [
                    {
                        text: 'Format ( Column A = 0, B = 1, C = 2... )',
                        model: 'format',
                    },
                    {
                        text: 'Constants',
                        model: 'constants',
                    },

                ],
            }
        },
        methods: {
            // @vuese
            // Deletes this manifest and POST the changes on the API.
            deleteManifest() {
                axios.delete(process.env.API_URL + '/manifestformats/' + this.manifest.id)
                    .then((response) => {
                        this.$store.commit('displaySnackbar', 'Manifest format deleted.');
                        this.$emit('cancel');
                    })
                    .catch((response) => {
                        this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                    })
            },
            // @vuese
            // Saves the changes made on the manifest. Handles both cases: editing or creating a new manifest and posts
            // those changes on the API.
            save() {
               const hasNegative = this.manifestFormatList.some((item) => item.value < 0);
               if(hasNegative){
                 this.$store.commit('displaySnackbar', 'column number must great than 0');
                 return;
               } else if(!this.manifest.client_id){
                 this.$store.commit('displaySnackbar', 'please select client');
                 return;
               }
              let parsedFormat = JSON.parse(this.manifest.format);
              parsedFormat = Object.fromEntries(Object.entries(parsedFormat).filter(
                ([key,value]) => value !== null && value !== ""
              ));
              this.manifest.format = JSON.stringify(parsedFormat);
              if (this.manifest.id > -1) {
                  axios.put(process.env.API_URL + '/manifestformats/' + this.manifest.id, this.manifest)
                      .then((response) => {
                          this.$store.commit('displaySnackbar', 'Changes saved on client: ' + this.client.name);
                          this.$emit('cancel');
                          this.$emit('putSuccess');
                      })
                      .catch((response) => {
                          this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                      })
              } else {
                  axios.post(process.env.API_URL + '/manifestformats', this.manifest)
                      .then((response) => {
                          this.$store.commit('displaySnackbar', 'New manifest format created.');
                          this.$emit('cancel');
                          this.$emit('putSuccess');
                      })
                      .catch((response) => {
                          this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                      })
              }
              this.isNew = true;
            },
            // @vuese
            // Gets all the regions.
            getRegions() {
                axios.get(process.env.API_URL + '/regions')
                    .then((response) => {
                        this.regions = response.data;
                        this.regions.unshift({id: 0, name: 'Global'});
                    })
                    .catch((response) => {
                        this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                    })
            },
            // @vuese
            // Gets all the clients
            getClients() {
                axios.get(process.env.API_URL + '/clients?inactive=true')
                    .then((response) => {
                        this.clients = response.data;
                    })
                    .catch((response) => {
                        this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                    })
            },
          getManifestFormat(){
              try{
                if(!this.manifest.format){
                  this.initManifestFormat();
                  this.manifest.format = this.manifestFormatList
                }
                const manifestFormat = JSON.parse(this.manifest.format);
                this.manifestFormatList.forEach((item) => {
                  if(manifestFormat.hasOwnProperty([item.name])){
                    item.value=manifestFormat[item.name];
                  }
                });
              } catch (error){
                console.error("Error geting format");
              }
          },
          updateManifestFormat(){
            this.manifest.format = JSON.stringify(this.manifestFormatList.reduce(
              (acc,item) => {
                acc[item.name] = item.value;
                return acc;
              },{}));
          },
          initManifestFormat(){
              for(let key in this.manifestFormatList){
                this.manifestFormatList[key].value = null;
              }

          }
        },
        mounted() {
            this.getRegions();
            this.getClients();
            this.getManifestFormat();
        },
        watch:{
          manifest:{
            handler(newVal){
              this.manifest.format = newVal.format;
              this.getManifestFormat();
            },
            deep: true
          }
        },
      computed:{
        isAdmin() {
          return this.$store.getters['auth/hasPermission']('delivery_admin');
        },
      }
    }
</script>

<style scoped>

  .editor {
    height: 200px;
  }
</style>

<style>
  .prism-editor-wrapper code {
    background-color: transparent;
    box-shadow: none;
  }
  .grid-container{
    display: grid;
    grid-template-columns: repeat(3,1fr);
    gap: 10px;
  }
  .grid-item{
    text-align: left;
    margin-left: 20px;
  }
  .item-name{
    margin-right: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/util/ManageManifests/EditManifest.vue